import { render, staticRenderFns } from "./taskDetails.vue?vue&type=template&id=e989910a&scoped=true"
import script from "./taskDetails.vue?vue&type=script&lang=js"
export * from "./taskDetails.vue?vue&type=script&lang=js"
import style0 from "./taskDetails.vue?vue&type=style&index=0&id=e989910a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e989910a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e989910a')) {
      api.createRecord('e989910a', component.options)
    } else {
      api.reload('e989910a', component.options)
    }
    module.hot.accept("./taskDetails.vue?vue&type=template&id=e989910a&scoped=true", function () {
      api.rerender('e989910a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/program/programList/taskDetails.vue"
export default component.exports